<template>
    <b-alert :show="dismissCountDown"
             dismissible
             variant="success"
             @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged"
             class="position-fixed"
             style="z-index:1; top:15px; right: 0px">
        <p class="pr-lg-5 pt-3">Сообщение успешно отправлено!</p>
    </b-alert>
</template>
<script>

export default {
    name: "CallAlert",
    data() {
        return {
            dismissCountDown: 0,
            showDismissibleAlert: false
        };
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = 5
        }
    }
}
</script>
<style>
</style>
